/**
 * 2026 S大会页面配置
 */

export const sectionTitles = {
  highlights: {
    zh: '大会亮点',
    en: 'HIGHLIGHTS',
  },
  guests: {
    zh: '大会嘉宾',
    en: 'GUESTS',
  },
  agenda: {
    zh: '大会议程',
    en: 'EVENT AGENDA',
  },
  aiForGood: {
    zh: 'AI向善产品',
    en: 'AI FOR GOOD PRODUCTS',
  },
  exhibition: {
    zh: '大会展区',
    en: 'EXHIBITION AREA',
  },
  videos: {
    zh: '精彩视频',
    en: 'VIDEO HIGHLIGHTS',
  },
  moments: {
    zh: '精彩瞬间',
    en: 'PHOTO GALLERY',
  },
  news: {
    zh: '大会资讯',
    en: 'NEWS',
  },
  reports: {
    zh: '行业报告',
    en: 'SSV REPORT',
  },
  partners: {
    zh: '合作伙伴',
    en: 'Partners',
  },
} as const;

/**
 * 获取标题文案
 */
export const getTitle = (key: keyof typeof sectionTitles, locale: string) => {
  return locale === 'zh' ? sectionTitles[key].zh : sectionTitles[key].en;
};
